export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_clients(state, {clients}) {
    state.clients = clients.data;
    state.totalCount = clients.total;
    state.count = clients.total;
  },
  set_clients2(state, {clients}) {
    state.clients = clients.data;
    state.totalCount = clients.total;
    state.count = clients.total;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  },
  
  setDownloadList(state, list){
    state.downloadList = list
  }
};
